<script lang="ts">
	import { Image } from "@unpic/svelte";
	import { twMerge } from "tailwind-merge";
	import type { Folder } from "#gen/folder/v1/folders_pb.js";
	import type { StaticAsset } from "#gen/staticassets/v1/static_assets_pb.js";
	import { isStaticAsset } from "#lib/bulk.js";
	import Icon from "#lib/components/Icon.svelte";
	import P from "#lib/components/P.svelte";
	import { getFileIcon } from "#lib/components/files/utils.js";
	import { UPLOADABLE_IMAGE_FILE_TYPES } from "#lib/components/images/constants.js";
	import Button from "#lib/ui/Button/index.js";

	interface Props {
		item: StaticAsset | Folder;
		selectedFile: StaticAsset | undefined;
		selectFile: (file: StaticAsset | Folder, checked: boolean) => void;
	}

	let { item, selectedFile, selectFile }: Props = $props();

	let fileIcon = $derived(getFileIcon(isStaticAsset(item) ? item.mimeType : undefined));
	let checked = $derived(isStaticAsset(item) ? selectedFile?.uploadUrl === item.uploadUrl : false);
</script>

<div class="flex shrink flex-col items-center justify-start">
	<Button on:click={() => selectFile(item, true)} class={twMerge("aspect-square h-[109px] w-[113px] overflow-clip border-2 p-0 outline-0", checked ? "border-primary-500 ring-0 outline-0! outline-offset-0" : "")} color="none" data-action-name="file-explorer-selected-file-tile">
		{#if isStaticAsset(item) && UPLOADABLE_IMAGE_FILE_TYPES.includes(item?.mimeType)}
			<Image loading="lazy" layout="fixed" height={113} width={113} src={item.uploadUrl} style="width: 100%; height: 100%; object-fit: contain;" />
		{:else}
			<Icon name={fileIcon.name} iconSet={fileIcon.iconSet} height={24} width={24} />
		{/if}
	</Button>
	<P align="center" size="xs" class="mt-2 max-w-24 truncate whitespace-nowrap">{item.name}</P>
</div>
